(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_carousel-content"] && !Shopify.designMode) return;
  try {
    function initSeamlessCarousels(scope = document) {
    scope.querySelectorAll('[data-seamless-carousel]').forEach((wrapper) => {
      if (wrapper.dataset.seamlessInitialized === 'true') return;

      const scroller = wrapper.querySelector('slideshow-slides');
      const originalCount = Number(wrapper.dataset.originalSlideCount);

      if (!scroller || !originalCount) return;

      const slides = Array.from(scroller.children).filter((slide) =>
        slide.matches('[data-carousel-card]')
      );

      if (slides.length < originalCount * 3) return;

      const getLoopWidth = () => {
        return slides[originalCount].offsetLeft - slides[0].offsetLeft;
      };

      const jumpWithoutAnimation = (position) => {
        const oldBehavior = scroller.style.scrollBehavior;

        scroller.style.scrollBehavior = 'auto';
        scroller.scrollLeft = position;

        requestAnimationFrame(() => {
          scroller.style.scrollBehavior = oldBehavior;
        });
      };

      /* Begin on the middle copy */
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const loopWidth = getLoopWidth();

          if (loopWidth) {
            jumpWithoutAnimation(loopWidth);
          }
        });
      });

      let scrollTimer;

      scroller.addEventListener(
        'scroll',
        () => {
          clearTimeout(scrollTimer);

          scrollTimer = setTimeout(() => {
            const loopWidth = getLoopWidth();
            if (!loopWidth) return;

            const currentPosition = scroller.scrollLeft;

            /*
             * Once scrolling finishes in one of the duplicate sets,
             * silently move to the identical position in the middle set.
             * Visually nothing changes.
             */
            if (currentPosition < loopWidth) {
              jumpWithoutAnimation(currentPosition + loopWidth);
            } else if (currentPosition >= loopWidth * 2) {
              jumpWithoutAnimation(currentPosition - loopWidth);
            }
          }, 80);
        },
        { passive: true }
      );

      wrapper.dataset.seamlessInitialized = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initSeamlessCarousels();
    });
  } else {
    initSeamlessCarousels();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initSeamlessCarousels(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
